//import React from 'react';

import React, { useState, useEffect } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";

import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from "@material-ui/icons/ShareTwoTone";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import Grid from "@material-ui/core/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormLabel from "@material-ui/core/FormLabel";
import TextField from "@material-ui/core/TextField";

import { getDefaultVoices } from "../shared/Voices";

export default function SettingsDialog(props) {
  // var G_german_voice;
  // var G_english_voice;
  // var G_spanish_voice;
  // var G_spanish_voice;

  // var found_voices = getDefaultVoices();
  // var G_spanish_voice = found_voices.G_spanish_voice;
  // var G_german_voice = found_voices.G_german_voice;
  // var G_english_voice = found_voices.G_english_voice;
  // var G_french_voice = found_voices.G_french_voice;

  var G_spanish_voice = props.settingSpeak.SpanishVoice;
  var G_german_voice = props.settingSpeak.GermanVoice;
  var G_english_voice = props.settingSpeak.EnglishVoice;
  var G_french_voice = props.settingSpeak.FrenchVoice;
  //alert(G_french_voice);

  var voices = speechSynthesis.getVoices();
  var voice_names = [];

  voices.forEach(function (voice, i) {
    voice_names.push(voice.name);
  });

  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    // alert(state.checkedA);
    //props.handleSettingsChanged(state.Present,state.Past,state.Past1,state.Future,state.Conditional,state.Imperativ,state.Imperativ1);

    //props.handleSettingsChanged(state.Right,state.Left,state.Up,state.Down,state.SpanishVoice,state.GermanVoice,state.EnglishVoice);
    var settings = {
      Present: state.Present,
      Past: state.Past,
      Past1: state.Past1,
      Future: state.Future,
      Conditional: state.Conditional,
      Imperativ: state.Imperativ,
      Imperativ1: state.Imperativ1,
      Verzug: state.Verzug,
      SpanishVoice: state.SpanishVoice,
      GermanVoice: state.GermanVoice,
      EnglishVoice: state.EnglishVoice,
      FrenchVoice: state.FrenchVoice,
      ItalianVoice: state.ItalianVoice,
    };

    props.handleSettingsChanged(settings);

    setOpen(false);
  }

  const [state, setState] = React.useState({
    Present: false,
    Past: false,
    Past1: false,
    Future: false,
    Conditional: false,
    Imperativ: false,
    Imperativ1: false,
    Verzug: 3,
    Languages: ["Language1", "Language2", "Language3"],
    SpanishVoice: "",
    GermanVoice: "",
    EnglishVoice: "",
    FrenchVoice: "",
    ItalianVoice: "",
    Voices: [],
    LanguageUsed: "Spanish",
  });

  const handleChangeSelect = (name) => (event) => {
    if (name == "LanguageUsed") {
      if (event.target.value == "Spanish") {
        setState({
          ...state,
          [name]: event.target.value,
          ["Right"]: "Language1",
          ["Left"]: "Language1",
          ["Down"]: "Language1",
          ["Up"]: "Language2",
        });
      }
      if (event.target.value == "German") {
        setState({
          ...state,
          [name]: event.target.value,
          ["Right"]: "Language2",
          ["Left"]: "Language2",
          ["Down"]: "Language2",
          ["Up"]: "Language1",
        });
      }
    } else {
      setState({ ...state, [name]: event.target.value });
    }
  };
  //voices = speechSynthesis.getVoices();
  //setState({ ...state, ["Voices"]: voices });

  useEffect(() => {
    if (state.Voices.length < 2) {
      setState({ ...state, ["Voices"]: voice_names });
      if (state.GermanVoice == "") {
        if (G_german_voice != undefined && G_german_voice != "") {
          setState({ ...state, ["GermanVoice"]: G_german_voice });
        }
      }
      if (state.EnglishVoice == "") {
        if (G_english_voice != undefined && G_english_voice != "") {
          setState({ ...state, ["EnglishVoice"]: G_english_voice });
        }
      }
      if (state.SpanishVoice == "") {
        if (G_spanish_voice != undefined && G_spanish_voice != "") {
          setState({ ...state, ["SpanishVoice"]: G_spanish_voice });
        }
      }
      if (state.FrenchVoice == "") {
        if (G_french_voice != undefined && G_french_voice != "") {
          setState({ ...state, ["FrenchVoice"]: G_french_voice });
        }
      }
    }
  });

  const handleChange = (name) => (event) => {
    setState({ ...state, [name]: event.target.checked });
  };

  const handleChangeText = (name) => (event) => {
    setState({ ...state, [name]: event.target.value });
  };

  //console.log(state.Voices);
  //console.log(voices);

  const ReadSelectedProperty = () => {
    const prop = this.getKeys(this.state);
  };

  var getKeys = function (obj) {
    var keys = [];
    for (var key in obj) {
      keys.push(key);
    }
    return keys;
  };

  return (
    <div>
      <IconButton aria-label="Share" onClick={handleClickOpen}>
        <ShareIcon />
      </IconButton>

      <Dialog
        fullWidth="sm"
        maxWidth="sm"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Settings222"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Edit settings
          </DialogContentText>

          <FormControlLabel
            control={
              <Checkbox
                checked={state.Present}
                onChange={handleChange("Present")}
                value="Present"
              />
            }
            label="Present"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={state.Past}
                onChange={handleChange("Past")}
                value="Past"
              />
            }
            label="Past"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={state.Past1}
                onChange={handleChange("Past1")}
                value="Past1"
              />
            }
            label="Past1"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={state.Future}
                onChange={handleChange("Future")}
                value="Future"
              />
            }
            label="Future"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={state.Conditional}
                onChange={handleChange("Conditional")}
                value="Conditional"
              />
            }
            label="Conditional"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={state.Imperativ}
                onChange={handleChange("Imperativ")}
                value="Imperativ"
              />
            }
            label="Imperativ"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={state.Imperativ1}
                onChange={handleChange("Imperativ1")}
                value="Imperativ1"
              />
            }
            label="Imperativ1"
          />

          <TextField
            fullWidth
            id="Verzug"
            label="Verzug"
            className="Verzug"
            value={state.Verzug}
            onChange={handleChangeText("Verzug")}
            margin="normal"
            max-width="100px"
          />

          <br></br>
          {/* <FormControl fullWidth>
            <InputLabel htmlFor="SpanishVoice">SpanishVoice</InputLabel>
            <Select
              value={state.SpanishVoice}
              onChange={handleChangeSelect("SpanishVoice")}
              inputProps={{
                name: "SpanishVoice",
                id: "name-simple"
              }}
            >
              {typeof state.Voices != "undefined" &&
                state.Voices.map(se => <MenuItem value={se}>{se}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel htmlFor="GermanVoice">GermanVoice</InputLabel>
            <Select
              value={state.GermanVoice}
              onChange={handleChangeSelect("GermanVoice")}
              inputProps={{
                name: "GermanVoice",
                id: "name-simple"
              }}
            >
              {typeof state.Voices != "undefined" &&
                state.Voices.map(se => <MenuItem value={se}>{se}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel htmlFor="EnglishVoice">EnglishVoice</InputLabel>
            <Select
              value={state.EnglishVoice}
              onChange={handleChangeSelect("EnglishVoice")}
              inputProps={{
                name: "EnglishVoice",
                id: "name-simple"
              }}
            >
              {typeof state.Voices != "undefined" &&
                state.Voices.map(se => <MenuItem value={se}>{se}</MenuItem>)}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel htmlFor="FrenchVoice">FrenchVoice</InputLabel>
            <Select
              value={state.FrenchVoice}
              onChange={handleChangeSelect("FrenchVoice")}
              inputProps={{
                name: "FrenchVoice",
                id: "name-simple"
              }}
            >
              {typeof state.Voices != "undefined" &&
                state.Voices.map(se => <MenuItem value={se}>{se}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel htmlFor="ItalianVoice">ItalianVoice</InputLabel>
            <Select
              value={state.ItalianVoice}
              onChange={handleChangeSelect("ItalianVoice")}
              inputProps={{
                name: "ItalianVoice",
                id: "name-simple"
              }}
            >
              {typeof state.Voices != "undefined" &&
                state.Voices.map(se => <MenuItem value={se}>{se}</MenuItem>)}
            </Select>
          </FormControl> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleClose} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
